/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'success': {
    width: 65,
    height: 65,
    viewBox: '0 0 65 65',
    data: '<path pid="0" _fill="#7ED321" fill-rule="evenodd" d="M9.531 9.531C15.885 3.177 23.541 0 32.5 0c8.958 0 16.615 3.177 22.969 9.531C61.823 15.885 65 23.541 65 32.5c0 8.958-3.177 16.615-9.531 22.969C49.115 61.823 41.459 65 32.5 65c-8.958 0-16.615-3.177-22.969-9.531C3.177 49.115 0 41.459 0 32.5c0-8.958 3.177-16.615 9.531-22.969zM27.5 44.063l20.938-21.094-2.813-2.813-19.531 19.688L18.75 32.5l-2.813 2.813 8.75 8.75c.417.416.886.624 1.407.624.52 0 .99-.208 1.406-.624z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/compiled-icons/success.js